/**
 * @file Consumer App Modal Names.
 */
export const CREATE_ACCOUNT_IDENTITY_MODAL = 'modal/CREATE_ACCOUNT_IDENTITY';
export const UPDATE_ACCOUNT_IDENTITY_MODAL = 'modal/UPDATE_ACCOUNT_IDENTITY';
export const DELETE_ACCOUNT_IDENTITY_MODAL = 'modal/DELETE_ACCOUNT_IDENTITY';
export const ACCOUNT_IDENTITY_SELFIE_PREVIEW =
  'modal/ACCOUNT_IDENTITY_SELFIE_PREVIEW';
